module.exports = __webpack_public_path__ + "static/img/SM@3x.2ec3e07e.png";